import type { CmsProps } from '../../types/cms'
import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const FooterContainer = styled.div<CmsProps>`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: flex-start;
  color: #fff;

  p,
  a,
  span {
    font-size: 16px;
    margin: 0;
  }

  ${({ theme }) => `${theme.breakpoints.down('sm')} {
    justify-content: space-evenly;
  }`}
`

export const SocialMediaLinkContainer = styled(Box)<CmsProps>`
  order: 0;
  flex-basis: 'auto';

  h3 {
    font-size: 20px;
  }

  ${({ theme }) => `${theme.breakpoints.down('sm')} {
    justify-content: space-evenly;
    order: -1;
    flex-basis: 100%;
  }`}
`

export const Nav = styled.nav<CmsProps>`
  a {
    display: block;
    text-align: right;
    text-decoration: underline;
  }
  p {
    font-size: 1rem;
    font-weight: 400;
    margin: 0;
  }
  h3 {
    text-align: center;
    font-size: 1.75rem;
    margin-bottom: 1rem;
    font-weight: 600;
  }
  img {
    padding: 0 0.5rem;
    cursor: pointer;
  }
  span {
    font-size: 1rem;
    font-weight: 400;
  }
`
